export default {
  name: "PropertyOverview",

  props: {
    centre: {
      type: Object,
      required: true,
    },
    total_centres: {
      type: Number,
      default: 1,
    },
  },

  methods: {
    formatKey(key) {
      return key
        .replace(/([A-Z])/g, " $1")
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());
    },
  },
};
